<template>

    <div>
        <div class="nav" v-if="!$store.state.isHideNav" :style="{zIndex:$store.state.navigatorZIndex}">

            <div class="nav-item" @click="onNavClick('Portal')">
                <div class="item-icon">
                    <img v-if="currRoute === 'Portal' || currRoute === 'ChooseProduct'" src="/img/Icon/home2.png" alt="">
                    <img v-else src="/img/Icon/home1.png" alt="">
                </div>
                <div class="item-text" :class="{active : currRoute === 'Portal' || currRoute === 'ChooseProduct'}">首页</div>
            </div>
            <div class="nav-item" @click="onNavClick('Catalog')">
                <div class="item-icon">
                    <img v-if="currRoute !== 'Catalog'" src="/img/Icon/cate1.png" alt="">
                    <img v-else src="/img/Icon/cate2.png" alt="">
                </div>
                <div class="item-text" :class="{active : currRoute === 'Catalog'}">分类</div>
            </div>
            <div class="nav-item" @click="onNavClick('MallCart')">
                <div class="item-icon">
                    <img v-if="currRoute !== 'MallCart'" src="/img/Icon/car1.png" alt="">
                    <img v-else src="/img/Icon/car2.png" alt="">
                </div>
                <div class="item-text" :class="{active : currRoute === 'MallCart'}" >购物车</div>
                <div class="_icon" v-if="mallCartCount > 0">{{mallCartCount}}</div>
            </div>
            <div class="nav-item" @click="onNavClick('My')">
                <div class="item-icon">
                    <img v-if="currRoute !== 'My-Personal'" src="/img/Icon/my1.png" alt="">
                    <img v-else src="/img/Icon/my2.png" alt="">
                </div>
                <div class="item-text" :class="{active : currRoute === 'My'}">我的</div>
            </div>

        </div>
    </div>

</template>

<script>
export default {
    name: "Navigation",
    
    props:{
        route:{
            default: null,
        },
        shoppingCartCount:{
            default: 0,
        },
        
    },
    data() {
        return {
            currRoute: '',
        }
    },
    created() {},
    mounted() {},

    computed: {
        mallCartCount(){
            return this.$store.state.mallCartCount;
        }
    },
    
    watch: {
        // 监听路由变化
        route:{
            handler(val){
                if(val){
                    this.currRoute = val.name;
                }
            },
            immediate: true,
        },

        mallCartCount:{
            handler(val){
                // console.log('~~监听 vuex 中数据变化~~', val)
            },
            immediate:true
        },
    },
    methods: {

        onNavClick(str) {
            if (str !== this.currRoute) {
                this.$router.push({
                    name: str, 
                    params: {mchId: this.$route.params.mchId}
                })
            }
        },
          

    },
    
}
</script>

<style scoped lang="scss">
    $navItemHeight: 1.45rem;

    .nav {
        border-top: 1px solid #f3f3f3;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: white;
        display: flex;
        border-top-left-radius: .2rem;
        border-top-right-radius: .2rem;
        width: 10rem;
        margin: auto;

        .nav-item {
            width: 25%;
            height: $navItemHeight;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: relative;

            ._icon {
                position: absolute;
                height: .44rem;
                background-color: #f66210;
                color: #fff;
                font-size: .28rem;
                border-radius: .4rem;
                display: flex;
                align-items: center;
                justify-content: center;
                top: 2px;
                right: 27%;
                padding: 0 .12rem;
                border: .04rem solid #fff;
            }

            .item-icon {
                display: flex;
                justify-content: center;
                align-items: center;

                & > img {
                    width: .6rem;
                    height: .55rem;
                }
            }

            .item-text {
                font-size: .32rem;
                text-align: center;
            }

            .active {
                color: #f7620e;
            }
        }
    }
</style>
